<h1 mat-mdc-dialog-title class="center">Validation du panier</h1>
<div mat-dialog-content>
  <p>Vos demandes sont en cours de validation, nous vous invitons à consulter le suivi de vos demandes dans votre espace client.</p>
  <p>Un email de confirmation vous a été envoyé, merci d'imprimer le récapitulatif à joindre au sac orange.</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="accept()">Fermer</button>
</div>